import React from 'react';
import { SUBJECT_COLOR_PALETTE, hexToRgba } from '../../utils/subjectColors';

export const DAYS = [
  { key: 'segunda', label: 'Segunda' },
  { key: 'terca', label: 'Terça' },
  { key: 'quarta', label: 'Quarta' },
  { key: 'quinta', label: 'Quinta' },
  { key: 'sexta', label: 'Sexta' },
  { key: 'sabado', label: 'Sábado' },
  { key: 'domingo', label: 'Domingo' }
];

export const formatDuration = (minutes) => {
  if (minutes === 90) return '1h30min';
  if (minutes === 60) return '1h';
  if (minutes < 60) return `${minutes}min`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest === 0 ? `${hours}h` : `${hours}h${rest}min`;
};

// Legenda + grade semanal do plano de estudos gerado. Reaproveitado tanto na tela
// de "Plano de Estudos" (modo visualização) quanto na tela de resultado do funil
// guiado (TrialResults), para o aluno ver o cronograma completo assim que termina
// as questões de treino.
function StudyPlanCalendar({ plan }) {
  if (!plan) return null;

  const weeklyMinutesBySubject = {};
  Object.values(plan.schedule).forEach((dayBlocks) => {
    (dayBlocks || []).forEach((block) => {
      weeklyMinutesBySubject[block.subjectId] =
        (weeklyMinutesBySubject[block.subjectId] || 0) + block.durationMinutes;
    });
  });

  return (
    <>
      <div className="study-plan-legend">
        {plan.subjects.map((subject, index) => (
          <span key={subject.subjectId} className="study-plan-legend-item">
            <span
              className="study-plan-legend-dot"
              style={{
                backgroundColor:
                  SUBJECT_COLOR_PALETTE[index % SUBJECT_COLOR_PALETTE.length].border
              }}
            />
            {subject.subjectName}
            <span className="study-plan-legend-duration">
              {formatDuration(weeklyMinutesBySubject[subject.subjectId] || 0)}/semana
            </span>
          </span>
        ))}
      </div>

      <div className="study-plan-calendar">
        {DAYS.map((day) => {
          const isStudyDay = plan.studyDays.includes(day.key);
          const blocks = plan.schedule[day.key] || [];
          return (
            <div
              key={day.key}
              className={`study-plan-calendar-day ${isStudyDay ? '' : 'rest-day'}`}
            >
              <div className="study-plan-calendar-day-header">{day.label}</div>
              {isStudyDay ? (
                <div className="study-plan-calendar-blocks">
                  {blocks.map((block, index) => {
                    const subjectIndex = plan.subjects.findIndex(
                      (s) => s.subjectId === block.subjectId
                    );
                    const pair =
                      SUBJECT_COLOR_PALETTE[
                        (subjectIndex >= 0 ? subjectIndex : 0) % SUBJECT_COLOR_PALETTE.length
                      ];
                    return (
                      <div
                        key={index}
                        className="study-plan-block"
                        style={{
                          borderLeftColor: pair.border,
                          backgroundColor: pair.bg,
                          '--block-bg-dark': hexToRgba(pair.border, 0.18)
                        }}
                      >
                        <span className="study-plan-block-subject">{block.subjectName}</span>
                        <span className="study-plan-block-duration">
                          {formatDuration(block.durationMinutes)}
                        </span>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="study-plan-rest-label">Sem estudo</div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}

export default StudyPlanCalendar;
